import React, { useState, forwardRef, useImperativeHandle } from "react";

import { SimpleDialog } from "simple-ui-components";

import { UpdateTechnician } from "./updateTechnician";
import { getTranslation } from "../languageProvider";

export const EditTechnician = forwardRef(
  ({ UpdateSuccess, technicianList }, ref) => {
    const { Dialog, DialogBody } = SimpleDialog;

    const [open, setOpen] = useState(false);
    const [clickedRoutes, setClickedRoutes] = useState({});

    const handleClose = () => setOpen(false);

    // trigger from props
    useImperativeHandle(ref, () => ({
      TechnicianHandler(route) {
        setOpen(true);
        setClickedRoutes(route);
      },
    }));

    return (
      <>
        {open && (
          <Dialog
            theme="default"
            size="lg"
            close={handleClose}
            open={open}
            title={`${getTranslation("0087")} ${getTranslation(
              "0088"
            ).toLowerCase()}`}
          >
            <DialogBody>
              <UpdateTechnician
                technicianList={technicianList}
                current={clickedRoutes}
                Success={UpdateSuccess}
              />
            </DialogBody>
          </Dialog>
        )}
      </>
    );
  }
);
